import * as React from 'react';

import StoreProviderWrapper from 'bundles/ai-coach-platform/components/patterns/chat/store/StoreProviderWrapper';
import SearchBarContentWrapper from 'bundles/search-common/components/searchbar/SearchBarContentWrapper';
import type { EnterpriseSearchBarConfig } from 'bundles/search-common/components/searchbar/searchBarWrapperTypes';

type Props = {
  enterpriseSearchBarConfig: EnterpriseSearchBarConfig;
};

const EnterpriseSearchBar = ({ enterpriseSearchBarConfig }: Props) => {
  return (
    <StoreProviderWrapper>
      <SearchBarContentWrapper
        searchBarConfig={{
          enterpriseSearchBarConfig,
        }}
      />
    </StoreProviderWrapper>
  );
};

export default EnterpriseSearchBar;
